import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import axios from "axios";
import "./AddDocumentToCase.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CaseFilesInternal from "../../../enums/CaseFilesInternal";
import {IoIosCloseCircle} from "react-icons/io";
import CaseFilesStatus from "../../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../../enums/CaseFileDeclined";
import {Button, FormControl, InputLabel, MenuItem, Select, TextField, Tooltip} from "@mui/material";
import {useLocation} from "react-router-dom";
import CaseDocumentInternalFlowStatusEnum from "../../../enums/CaseDocumentInternalFlowStatusEnum";
import JoditEditor from "jodit-react";
import {jwtDecode} from "jwt-decode";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";
import DepartmentEnum from "../../../enums/departmentEnums";
import DepartmentsPrefixEnum from "../../../enums/departmentsPrefixEnum";
import {IoEye, IoTrash} from "react-icons/io5";
import htmlEnums from "../../../enums/htmlEnums";
import TemplateEnum from "../../../enums/templateEnum";
import {debounce} from "lodash";
import {formatHtmlForEditor} from "../../../components/globalFunctions/globalFunctions";
import dummyFiles from "./base64";
import {AiOutlineCheckCircle} from "react-icons/ai";
import AllowedFormatsInfo from "./AllowedFormatsInfo";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";

const AddAnswerFromAnotherDepartment = ({
                                            onFileAdded,
                                            departments,
                                            fileId,
                                            docType,
                                            barcode,
                                            buttonTitle,
                                            users,
                                            permitTypeTitle,
                                            ownerIdentificationTemplateString,
                                            exploitationIdentificationTemplateString,
                                            caseInfo,
                                            departmentId,
                                            userAddress
                                        }) => {
    const [title, setTitle] = useState("");
    const [documentType, setDocumentType] = useState("");
    const [extraDescription, setExtraDescription] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editorContent, setEditorContent] = useState('');
    const [closing, setClosing] = useState(false);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [previewContent, setPreviewContent] = useState('');
    const isSubmitDisabled = !title || isEditorContentEmpty(editorContent) || !documentType || loading;
    const [fontFamily, setFontFamily] = useState('Sylfaen');
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');
    const [closeModalOn, setCloseModalOn] = useState(false);
    const [documentId, setDocumentId] = useState('');
    const [roleId, setRoleId] = useState('');
    const [userId, setUserId] = useState('');
    const [userDepartment, setUserDepartment] = useState('');
    const [docPrefix, setDocPrefix] = useState('');
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const fileInputRef = useRef(null);
    const caseIdForFile = new URLSearchParams(location.search).get('id');
    const [headerContent, setHeaderContent] = useState('');
    const [htmlLoaded, setHtmlLoaded] = useState(false);
    const [debouncedContent, setDebouncedContent] = useState(editorContent);
    const [mainUserId, setMainUserId] = useState("");

    const [attachments, setAttachments] = useState([]);
    const allowedAttachmentMimeTypes = [
        "application/pdf",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/svg+xml",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
        "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
        "text/csv",
        "application/zip",
        "application/x-rar-compressed"
    ];

    const handleFontChange = (e) => {
        setFontFamily(e.target.value);
    };

    const uploadFileToGetDocumentNumber = async () => {
        const filePayload = {
            caseID: parseInt(caseId),
            name: "test",
            ext: "pdf",
            file: dummyFiles.dummy,
            mainInfo: "",
            additionalInfo: "",
            shared: true,
            blank: false,
            documentType: 0,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.Sent,
            decline: CaseFileDeclined.No,
            declinedInternalStatus: 0
        };
        const created = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, filePayload);
        const caseFilesResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseFileByCaseID?CaseId=${caseId}`);
        const allCaseFiles = caseFilesResponse.data.data.resultItems;
        const createdFile = allCaseFiles.find(f => f.id === parseInt(created.data.resultId));
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseFile`, {caseFileId: created.data.resultId});
        return createdFile.documentNumber;
    };

    useEffect(() => {
        const token = localStorage.getItem("jwtTokenMain");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setMainUserId(decoded.UserId);
            } catch {
                setRoleId("");
            }
        }
    }, []);

    const debouncedUpdatePreview = useCallback(debounce(newContent => {
        setDebouncedContent(newContent);
    }, 50), []);

    useEffect(() => {
        debouncedUpdatePreview(editorContent);
    }, [editorContent, debouncedUpdatePreview]);

    const PdfPreviewContent = useMemo(() => {
        return (
            <div className="pdf-preview-container" style={{fontFamily}}>
                <Button variant="contained" color="primary" style={{marginBottom: 28}} startIcon={<AiOutlineCheckCircle/>}>
                    ცვლილების ნახვა
                </Button>
                <div id="pdf-page" className="pdf-page" style={{fontFamily}}>
                    <div dangerouslySetInnerHTML={{__html: headerContent}}/>
                    <div dangerouslySetInnerHTML={{__html: previewContent}}/>
                    <div style={{marginTop: 10}} dangerouslySetInnerHTML={{__html: debouncedContent}}/>
                </div>
            </div>
        );
    }, [fontFamily, previewContent, debouncedContent, headerContent]);

    const handleFilesChange = (event) => {
        const selectedFiles = Array.from(event.target.files || []);
        if (!selectedFiles.length) return;
        let hadInvalid = false;
        const prepared = selectedFiles.reduce((acc, f, idx) => {
            if (allowedAttachmentMimeTypes.includes(f.type)) {
                acc.push({
                    id: `${Date.now()}_${idx}_${Math.random().toString(36).slice(2, 8)}`,
                    file: f,
                    title: "დანართი"
                });
            } else {
                hadInvalid = true;
            }
            return acc;
        }, []);
        if (hadInvalid) {
            setAlert({show: true, message: "შეცდომა: ატვირთეთ მხოლოდ დასაშვები ტიპის ფაილები.", type: "error"});
        } else if (prepared.length > 0) {
            setAlert({show: true, message: "ფაილი წარმატებით აიტვირთა.", type: "success"});
        } else if (alert.show) {
            setAlert({...alert, show: false});
        }
        setAttachments(prev => [...prev, ...prepared]);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const handleAttachmentDelete = (attachmentId) => {
        setAttachments(prev => prev.filter(a => a.id !== attachmentId));
    };

    const handleAttachmentTitleChange = (attachmentId, value) => {
        setAttachments(prev => prev.map(a => a.id === attachmentId ? {...a, title: value} : a));
    };

    const handlePreview = (file) => {
        if (file) {
            const url = URL.createObjectURL(file);
            window.open(url, "_blank");
        }
    };

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });

    const performUploadAll = async (parentDocId) => {
        if (!attachments.length) return;
        for (const a of attachments) {
            const fileBase64 = await toBase64(a.file);
            const ext = a.file.name.split(".").pop();
            const fileData = {
                caseID: parseInt(caseIdForFile),
                name: a.title || "დანართი",
                ext,
                file: fileBase64,
                mainInfo: "",
                additionalInfo: "",
                sharedTemp: true,
                shared: false,
                blank: false,
                documentType: 1,
                internal: CaseFilesInternal.No,
                status: CaseFilesStatus.ReadyForVisage,
                decline: CaseFileDeclined.No,
                parentId: parentDocId,
                declinedInternalStatus: 0,
                activeUserId: userId
            };
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, fileData);
            } catch {}
        }
        setAttachments([]);
        if (fileInputRef.current) fileInputRef.current.value = "";
        onFileAdded();
    };

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
                setUserId(decoded.UserId);
            } catch {
                setRoleId("");
                setUserId("");
            }
        }
    }, []);

    useEffect(() => {
        if (userId) {
            const currentUser = users.find(u => u.id === userId);
            if (currentUser) {
                setUserDepartment(currentUser.departmentId);
            }
        }
    }, [userId, users]);

    useEffect(() => {
        if (userDepartment) {
            if (userDepartment === DepartmentEnum.technical.id) setDocPrefix(DepartmentsPrefixEnum.technicalAnswer);
            else if (userDepartment === DepartmentEnum.building.id) setDocPrefix(DepartmentsPrefixEnum.buildingAnswer);
            else if (userDepartment === DepartmentEnum.legal.id) setDocPrefix(DepartmentsPrefixEnum.legalAnswer);
            else if (userDepartment === DepartmentEnum.administration.id) setDocPrefix(DepartmentsPrefixEnum.administrationAnswer);
            else setDocPrefix(null);
        }
    }, [userDepartment]);

    const sendNotification = async (fileId) => {
        const headOfAgency = users.find(u => u.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(u => u.roleName === "DeputyHeadOfAgency");
        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: fileId,
            action: CaseNotificationEnum.createdFile.id,
            caseStatus: 8,
            viewed: true
        };
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Insert link": "ბმულის ჩასმა",
        "URL": "ბმული",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "ჩასმა"
    };

    const mapFontFamilyToStyles = (fontName) => {
        const fontStyles = {
            'Arial': { fontFamily: 'arial_geo', bold: 'arial_geo-bold', italics: 'arial_geo-italic', bolditalics: 'arial_geo-bold-italic' },
            'Sylfaen': { fontFamily: 'sylfaen', bold: 'arial_geo-bold', italics: 'arial_geo-italic', bolditalics: 'arial_geo-bold-italic' }
        };
        return fontStyles[fontName] || fontStyles['Arial'];
    };

    const editorConfig = useMemo(() => ({
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: { ka: georgianTranslations },
        style: { fontFamily: mapFontFamilyToStyles(fontFamily).fontFamily },
        height: 800,
        disablePlugins: [
            'spellcheck','speech-recognize','open-in-fullsize','add-new-line','Insert-file','ai-assistant','file','image','video','fullsize','about','preview','symbols','symbol'
        ],
        controls: { font: { list: { 'Arial': 'Arial', 'Sylfaen': 'Sylfaen' } } },
        buttons: ["bold","italic","underline","|","subscript","superscript"]
    }), []);

    useEffect(() => {
        const styleSheet = document.createElement('style');
        styleSheet.type = 'text/css';
        styleSheet.innerText = `.jodit-container * { font-family: ${mapFontFamilyToStyles(fontFamily).fontFamily} !important; }`;
        document.head.appendChild(styleSheet);
        return () => { document.head.removeChild(styleSheet); };
    }, [fontFamily]);

    const preprocessHtmlForPdf = (html, docNumber) => {
        const container = document.createElement('div');
        container.innerHTML = html.replace('{დოკუმენტის ნომერი}', "№ " + docNumber);
        const elementsWithStyle = container.querySelectorAll('[style]');
        elementsWithStyle.forEach(element => {
            const style = element.style;
            if (style.fontSize && isNaN(parseFloat(style.fontSize))) style.fontSize = '16px';
            if (style.textDecoration === 'none') style.textDecoration = '';
        });
        const tables = container.querySelectorAll('table');
        tables.forEach(table => {
            table.style.width = '100%';
            const rows = table.querySelectorAll('tr');
            rows.forEach(tr => {
                tr.querySelectorAll('td, th').forEach(td => { td.style.padding = '8px'; });
            });
        });
        return container.innerHTML;
    };

    useEffect(() => {
        const run = async () => {
            if (docType && htmlLoaded && userDepartment) {
                setDocumentType(docType.documentTypeStatus);
                setTitle(docType.name);
                let blankHtmlContent = docType.blank;
                const barcodeImageBase64 = barcode;
                if (barcodeImageBase64 && docType.templateType !== TemplateEnum.insideLetter) {
                    blankHtmlContent = insertBarcodeIntoContent(barcodeImageBase64, blankHtmlContent);
                } else if (barcodeImageBase64 && docType.templateType === TemplateEnum.insideLetter) {
                    blankHtmlContent = insertBarcodeIntoContentForInsideLetter(barcodeImageBase64, blankHtmlContent);
                }
                setPreviewContent(blankHtmlContent);
                if (docType.templateType !== null) {
                    if (docType.templateType === TemplateEnum.order) setHeaderContent(htmlEnums.order);
                    else if (docType.templateType === TemplateEnum.letter) setHeaderContent(htmlEnums.letter);
                }
                setPreviewContent(blankHtmlContent);
            }
        };
        void run();
    }, [docType, htmlLoaded, userDepartment, barcode]);

    useEffect(() => {
        if (htmlEnums && Object.keys(htmlEnums).length > 0) setHtmlLoaded(true);
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') setCloseModalOn(true);
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => { window.removeEventListener('keydown', handleKeyDown); };
    }, [closing, showPopup]);

    const preprocessEditorContent = (htmlContent) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        doc.querySelectorAll('p, br').forEach(el => {
            if (el.style.marginTop === '70px') el.style.marginTop = '0px';
        });
        return doc.body.innerHTML;
    };

    useEffect(() => {
        const processedContent = preprocessEditorContent(editorContent);
        setEditorContent(processedContent);
    }, [editorContent]);

    const resetForm = () => {
        setTitle("");
        setEditorContent("");
        setExtraDescription("");
        setDocumentType("");
    };

    function isEditorContentEmpty(content) {
        return !content.replace(/<[^>]*>/g, '').trim();
    }

    const insertBarcodeIntoContent = (base64ImageData, htmlContent) => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = htmlContent

        const table = document.createElement('table')
        table.style.width = '100%'
        table.style.borderCollapse = 'collapse'
        table.style.border = 'none'

        const headerRow = document.createElement('tr')

        const dateTableCell = document.createElement('td')
        dateTableCell.style.verticalAlign = 'middle'
        dateTableCell.style.border = 'none'
        dateTableCell.style.padding = '0'
        dateTableCell.style.color = 'black'
        dateTableCell.style.fontFamily = 'Sylfaen'
        dateTableCell.style.fontSize = '20px'
        dateTableCell.textContent = '{ხელმოწერის თარიღი}'

        headerRow.appendChild(dateTableCell)

        const barcodeTableCell = document.createElement('td')
        barcodeTableCell.style.verticalAlign = 'middle'
        barcodeTableCell.style.textAlign = 'right'
        barcodeTableCell.style.border = 'none'
        barcodeTableCell.style.padding = '0'

        const barcodeContainer = document.createElement('div')

        const barcodeImage = document.createElement('img')
        barcodeImage.src = base64ImageData
        barcodeImage.style.width = '200px'
        barcodeImage.style.height = '50px'

        barcodeContainer.appendChild(barcodeImage)

        const generateRandomNumberString = length => {
            let generatedValue = ''
            for (let index = 0; index < length; index++) {
                generatedValue += Math.floor(Math.random() * 10)
            }
            return generatedValue
        }

        const barcodeText = 'KA' + generateRandomNumberString(15)

        const barcodeTextDiv = document.createElement('div')
        barcodeTextDiv.style.fontSize = '14px'
        barcodeTextDiv.style.color = 'black'
        barcodeTextDiv.style.fontFamily = 'Sylfaen'
        barcodeTextDiv.textContent = barcodeText

        barcodeContainer.appendChild(barcodeTextDiv)
        barcodeTableCell.appendChild(barcodeContainer)

        headerRow.appendChild(barcodeTableCell)
        table.appendChild(headerRow)

        const documentRow = document.createElement('tr')

        const documentNumberCell = document.createElement('td')
        documentNumberCell.style.verticalAlign = 'middle'
        documentNumberCell.style.border = 'none'
        documentNumberCell.style.padding = '0'
        documentNumberCell.style.paddingTop = '50px'

        const documentNumberDiv = document.createElement('div')
        documentNumberDiv.textContent = '{დოკუმენტის ნომერი}'
        documentNumberDiv.style.fontSize = '18px'
        documentNumberDiv.style.color = 'black'
        documentNumberDiv.style.fontFamily = 'Sylfaen'

        documentNumberCell.appendChild(documentNumberDiv)

        const emptyCell = document.createElement('td')
        emptyCell.style.border = 'none'
        emptyCell.style.padding = '0'

        documentRow.appendChild(documentNumberCell)
        documentRow.appendChild(emptyCell)

        table.appendChild(documentRow)

        tempDiv.appendChild(table)
        return tempDiv.innerHTML
    }

    const insertBarcodeIntoContentForInsideLetter = (base64ImageData) => {
        const receiverHeadOfDepartment = users.find(u => u.departmentId === departmentId && u.roleName === "HeadOfDepartment");
        const senderHeadOfDepartment = users.find(u => u.departmentId === userDepartment && u.roleName === "HeadOfDepartment");
        const departmentName = departments.find(d => d.id === departmentId).name + "ს";
        const userDepartmentName = departments.find(d => d.id === userDepartment).name + "ს";
        let headOfDepartmentName;
        let senderName;
        if (receiverHeadOfDepartment.firstName === "მირიან" && receiverHeadOfDepartment.lastName === "ბედიანიძე") headOfDepartmentName = "მირიან ბედიანიძეს";
        else if (receiverHeadOfDepartment.firstName === "ამირან" && receiverHeadOfDepartment.lastName === "კაცაძე") headOfDepartmentName = "ამირან კაცაძეს";
        else if (receiverHeadOfDepartment.firstName === "ვასილ" && receiverHeadOfDepartment.lastName === "ანდღულაძე") headOfDepartmentName = "ვასილ ანდგულაძეს";
        else if (receiverHeadOfDepartment.firstName === "დავით" && receiverHeadOfDepartment.lastName === "კუხიანიძე") headOfDepartmentName = "დავით კუხიანიძეს";
        else headOfDepartmentName = receiverHeadOfDepartment.firstName === "ვასილ" + receiverHeadOfDepartment.lastName + "-(ს)";
        if (senderHeadOfDepartment.firstName === "მირიან" && senderHeadOfDepartment.lastName === "ბედიანიძე") senderName = "მირიან ბედიანიძის";
        else if (senderHeadOfDepartment.firstName === "ამირან" && senderHeadOfDepartment.lastName === "კაცაძე") senderName = "ამირან კაცაძის";
        else if (senderHeadOfDepartment.firstName === "ვასილ" && senderHeadOfDepartment.lastName === "ანდღულაძე") senderName = "ვასილ ანდგულაძის";
        else if (senderHeadOfDepartment.firstName === "დავით" && senderHeadOfDepartment.lastName === "კუხიანიძე") senderName = "დავით კუხიანიძის";
        else senderName = receiverHeadOfDepartment.firstName + receiverHeadOfDepartment.lastName + "-(ის)";
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = "<div></div>";
        const contentContainer = document.createElement('div');
        contentContainer.style.position = 'relative';
        contentContainer.style.width = '100%';
        contentContainer.style.textAlign = 'right';
        tempDiv.appendChild(contentContainer);
        const barcodeImg = document.createElement('img');
        barcodeImg.src = base64ImageData;
        barcodeImg.style.width = '170px';
        barcodeImg.style.height = '40px';
        barcodeImg.style.marginRight = '15px';
        contentContainer.appendChild(barcodeImg);
        function generateRandomNumberString(length) {
            let result = '';
            for (let i = 0; i < length; i++) result += Math.floor(Math.random() * 10);
            return result;
        }
        const randomCode = document.createElement('div');
        randomCode.style.fontSize = '12px';
        randomCode.style.color = 'black';
        randomCode.style.fontFamily = 'Sylfaen';
        randomCode.textContent = 'KA' + generateRandomNumberString(15);
        randomCode.style.marginRight = '15px';
        contentContainer.appendChild(randomCode);
        const insideLetterHTML = htmlEnums.insideLetter;
        const insideLetterDiv = document.createElement('div');
        insideLetterDiv.innerHTML = insideLetterHTML;
        insideLetterDiv.style.marginTop = '10px';
        insideLetterDiv.style.textAlign = 'center';
        insideLetterDiv.style.width = '100%';
        contentContainer.appendChild(insideLetterDiv);
        const noSpan = document.createElement('span');
        noSpan.textContent = "{დოკუმენტის ნომერი}";
        noSpan.style.display = 'block';
        noSpan.style.textAlign = 'right';
        noSpan.style.fontSize = '18px';
        noSpan.style.color = 'black';
        noSpan.style.fontFamily = 'Sylfaen';
        noSpan.style.textDecoration = 'none';
        noSpan.style.marginRight = '20px';
        noSpan.style.marginBottom = '5px';
        contentContainer.appendChild(noSpan);
        const dateSpan = document.createElement('span')
        dateSpan.textContent = "{ხელმოწერის თარიღი}"
        dateSpan.style.fontSize = '18px'
        dateSpan.style.color = 'black'
        dateSpan.style.marginRight = '15px'
        dateSpan.style.fontFamily = 'Sylfaen'
        dateSpan.style.letterSpacing = '-0.5px'

        contentContainer.appendChild(dateSpan)

        const officialDetailsSpan = document.createElement('span');
        officialDetailsSpan.innerHTML = `
        <p>სსიპ ტექნიკური და სამშენებლო ზედამხედველობის სააგენტოს ${departmentName} პირველადი სტრუქტურული ერთეულის ხელმძღვანელს ${headOfDepartmentName}</p>
        <p>სსიპ ტექნიკური და სამშენებლო ზედამხედველობის სააგენტოს ${userDepartmentName} პირველადი სტრუქტურული ერთეულის ხელმძღვანელის ${senderName}</p>`;
        officialDetailsSpan.style.display = 'block';
        officialDetailsSpan.style.marginTop = '15px';
        officialDetailsSpan.style.marginBottom = '15px';
        officialDetailsSpan.style.fontSize = '16px';
        officialDetailsSpan.style.color = 'black';
        officialDetailsSpan.style.fontFamily = 'Sylfaen';
        officialDetailsSpan.style.textAlign = 'justify';
        officialDetailsSpan.style.marginLeft = '500px';
        contentContainer.appendChild(officialDetailsSpan);
        return tempDiv.innerHTML;
    };

    const handleClosePopup = () => {
        setCloseModalOn(false);
        setClosing(true);
        setTimeout(() => {
            setShowPopup(false);
            setClosing(false);
        }, 500);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsConfirmModalOpen(true);
    };

    const replacePlaceholders = (htmlContent) => {
        let createDate;
        const date = new Date(caseInfo.createDate);
        if (isNaN(date)) createDate = 'caseDate';
        else createDate = `${date.getDate().toString().padStart(2,'0')}/${(date.getMonth()+1).toString().padStart(2,'0')}/${date.getFullYear()}`;
        const requester = users.find(u => u.id === userId);
        const mainUser = users.find(u => u.id === mainUserId);
        const signeeUser = users.find(u => u.departmentId === requester.departmentId && u.roleName === "HeadOfDepartment");
        const receiverHeadOfDepartment = users.find(u => u.departmentId === departmentId && u.roleName === "HeadOfDepartment");
        if (userId === mainUserId) {
            return htmlContent
                .replace(/\$requesterName\$/g, requester.firstName + ' ' + requester.lastName)
                .replace(/\$receiverName\$/g, receiverHeadOfDepartment ? receiverHeadOfDepartment.firstName + ' ' + receiverHeadOfDepartment.lastName : "(აირჩიეთ დეპარტამენტი)")
                .replace(/\$signee\$/g, signeeUser.firstName + ' ' + signeeUser.lastName)
                .replace(/\$caseDate\$/g, createDate)
                .replace(/\$address\$/g, userAddress)
                .replace(/\$permitType\$/g, permitTypeTitle)
                .replace(/\$objectOwnerIdentificationNumber\$/g, ownerIdentificationTemplateString)
                .replace(/\$exploitationIdentificationNumber\$/g, exploitationIdentificationTemplateString)
                .replace(/\$objectName\$/g, caseInfo.request)
                .replace(/\$caseNumber\$/g, caseInfo.caseNumber.toString());
        } else {
            return htmlContent
                .replace(/\$requesterName\$/g, requester.firstName + ' ' + requester.lastName + "(-ის) მოვალეობის შემსრულებელი " + mainUser.firstName + ' ' + mainUser.lastName)
                .replace(/\$receiverName\$/g, receiverHeadOfDepartment ? receiverHeadOfDepartment.firstName + ' ' + receiverHeadOfDepartment.lastName : "(აირჩიეთ დეპარტამენტი)")
                .replace(/\$signee\$/g, signeeUser.firstName + ' ' + signeeUser.lastName)
                .replace(/\$caseDate\$/g, createDate)
                .replace(/\$address\$/g, userAddress)
                .replace(/\$permitType\$/g, permitTypeTitle)
                .replace(/\$objectOwnerIdentificationNumber\$/g, ownerIdentificationTemplateString)
                .replace(/\$exploitationIdentificationNumber\$/g, exploitationIdentificationTemplateString)
                .replace(/\$objectName\$/g, caseInfo.request)
                .replace(/\$caseNumber\$/g, caseInfo.caseNumber.toString());
        }
    };

    useEffect(() => {
        if (docType.textHTML && mainUserId) {
            const updatedContent = replacePlaceholders(docType.textHTML);
            setEditorContent(updatedContent);
        }
    }, [docType.textHTML, mainUserId]);

    const handleConfirmSubmit = async () => {
        setIsConfirmModalOpen(false);
        setLoading(true);
        const fileNumber = await uploadFileToGetDocumentNumber();
        const forceFontFamily = (htmlContent) => {
            const container = document.createElement('div');
            container.innerHTML = htmlContent;
            Array.from(container.querySelectorAll("*")).forEach(el => { el.style.fontFamily = fontFamily; });
            return container.innerHTML;
        };
        const updatedPreviewContent = forceFontFamily(previewContent.replace(/background-color:\s*transparent;\s*/g, ''));
        const updatedEditorContent = forceFontFamily(editorContent.replace(/background-color:\s*transparent;\s*/g, ''));
        setPreviewContent(updatedPreviewContent);
        setEditorContent(updatedEditorContent);
        const processedContent = preprocessHtmlForPdf(
            `<div style="font-family: ${fontFamily}">${headerContent}${updatedPreviewContent}${updatedEditorContent}</div>`,
            docPrefix + fileNumber
        );
        const processedHtml = formatHtmlForEditor(processedContent);
        const requestBody = {
            caseID: parseInt(caseId),
            name: title,
            ext: 'pdf',
            mainInfo: processedHtml,
            additionalInfo: extraDescription,
            sharedTemp: false,
            shared: false,
            blank: true,
            documentType: documentType,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.ReadyForVisage,
            decline: CaseFileDeclined.No,
            approvalDocument: false,
            declinedInternalStatus: 0,
            answerStatus: CaseDocumentInternalFlowStatusEnum.SentToHead,
            pureDays: fileId,
            casefileNumber: docPrefix + fileNumber,
            html: processedHtml,
            isHTML: true,
            skipVisage: docType.skipVisage
        };
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBody);
            setDocumentId(response.data.resultId);
            await performUploadAll(response.data.resultId);
            onFileAdded();
            resetForm();
        } catch {
        } finally {
            setLoading(false);
            setShowPopup(false);
        }
    };

    useEffect(() => {
        const run = async () => {
            if (documentId) {
                await sendNotification(documentId);
                onFileAdded();
            }
        };
        void run();
    }, [documentId]);

    useEffect(() => {
        if (showPopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showPopup]);

    const closeAlert = () => setAlert({...alert, show: false});

    return (
        <div>
            <button className={"document-button"} onClick={() => { setShowPopup(true); }} disabled={loading}>{buttonTitle}</button>
            {showPopup && <div className="overlay" onClick={() => setCloseModalOn(true)}></div>}
            {showPopup && (
                <div className={`custom-scrollbar popup-editor ${closing ? 'popup-closing' : ''}`}>
                    {loading ? (
                        <div className="loader"></div>
                    ) : (
                        <div className="editor-and-preview-container">
                            <div>
                                <form onSubmit={handleSubmit}>
                                    <input
                                        type="text"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        placeholder="სათაური"
                                        className={"add-doc-input"}
                                    />
                                    <div className="q-editor-container">
                                        <FormControl fullWidth style={{marginBottom: 8}}>
                                            <InputLabel id="font-family-label">შრიფტი</InputLabel>
                                            <Select
                                                labelId="font-family-label"
                                                value={fontFamily}
                                                label="შრიფტი"
                                                onChange={handleFontChange}
                                                sx={{backgroundColor: 'white', borderRadius: 1}}
                                            >
                                                <MenuItem value="DejaVu">DejaVu Sans</MenuItem>
                                                <MenuItem value="Sylfaen">Sylfaen</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <JoditEditor
                                            key={fontFamily}
                                            value={editorContent}
                                            config={editorConfig}
                                            tabIndex={1}
                                            onBlur={value => setEditorContent(value)}
                                        />
                                    </div>
                                    <textarea
                                        value={extraDescription}
                                        onChange={(e) => setExtraDescription(e.target.value)}
                                        placeholder="დამატებითი აღწერა"
                                        style={{width: "99.39%", height: "200px", resize: "vertical", margin: "10px 0"}}
                                    />
                                    <Tooltip title={isSubmitDisabled ? "შეავსეთ ყველა ველი" : ""}>
                                        <button
                                            type="submit"
                                            style={{
                                                backgroundColor: isSubmitDisabled ? '#ccc' : '#2E76E4',
                                                color: isSubmitDisabled ? '#666' : 'white',
                                                cursor: isSubmitDisabled ? 'not-allowed' : 'pointer'
                                            }}
                                            className="doc-submit-button"
                                            disabled={isSubmitDisabled}
                                        >
                                            დოკუმენტის შექმნა
                                        </button>
                                    </Tooltip>
                                </form>
                            </div>
                            <div className="pdf-preview-container" style={{fontFamily}}>
                                {PdfPreviewContent}
                                <div>
                                    <div className="upload-single-container-decline">
                                        <div className="upload-single-header">
                                            <p className="upload-single-title">დანართის ატვირთვა</p>
                                            <AllowedFormatsInfo/>
                                        </div>
                                        <div className="upload-single-body">
                                            <Button variant="contained" onClick={() => fileInputRef.current.click()} className="upload-single-button">
                                                აირჩიეთ ფაილი
                                            </Button>
                                            <input
                                                type="file"
                                                multiple
                                                accept=".pdf,.jpg,.jpeg,.png,.svg,.xls,.xlsx,.xlsm,.xlsb,.csv,.zip,.rar"
                                                ref={fileInputRef}
                                                style={{display: "none"}}
                                                onChange={handleFilesChange}
                                            />
                                            {attachments.map(a => (
                                                <div key={a.id} className="upload-single-selected-file">
                                                    {a.file.name}
                                                    <IoTrash className="icon-button" onClick={() => handleAttachmentDelete(a.id)} />
                                                    <IoEye className="icon-button" onClick={() => handlePreview(a.file)} />
                                                    <TextField
                                                        label="ფაილის სახელი"
                                                        variant="outlined"
                                                        type="text"
                                                        value={a.title}
                                                        onChange={(e) => handleAttachmentTitleChange(a.id, e.target.value)}
                                                        sx={{ ml: 1 }}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    <IoIosCloseCircle className="upload-single-close-icon-text-editor" onClick={() => setCloseModalOn(true)} />
                    <ConfirmationModal
                        isOpen={isConfirmModalOpen}
                        onRequestClose={() => setIsConfirmModalOpen(false)}
                        onConfirm={handleConfirmSubmit}
                    />
                    <ConfirmationModal
                        isOpen={closeModalOn}
                        onRequestClose={() => setCloseModalOn(false)}
                        onConfirm={handleClosePopup}
                        modalText={"დახურვის შემთხვევაში წაიშლება პროგრესიც!"}
                    />
                </div>
            )}
            {alert.show && (
                <CustomAlert
                    message={alert.message}
                    type={alert.type}
                    onClose={closeAlert}
                />
            )}
            {loading && <div className="loader"></div>}
        </div>
    );
};

export default AddAnswerFromAnotherDepartment;
